import {AppraiserProfileFile} from "../../../api/ApiTypes.ts";
import {FileDownloadType, FileViewer} from "../../../components/FileViewer.tsx";
import {formatDateTime} from "../../../utils/dateUtils.ts";

export const DocumentsTable: React.FC<{ files: AppraiserProfileFile[] }> = ({ files }) => (
    <div className="overflow-x-auto rounded-xl shadow-lg">
        <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
            <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Type</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Name</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Size</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Uploaded by</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Date & Time Uploaded</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">Actions</th>
            </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
            {files.map((file) => (
                <tr key={file.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{file.id}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{file.fileType}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{file.fileName}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{file.fileSize}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{file.uploadedBy}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatDateTime(file.uploadDate)}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        <FileViewer fileId={file.id} fileIs={FileDownloadType.APPRAISER_PROFILE}/>
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
    </div>
);